module.exports = __webpack_public_path__ + "img/zendesk.da67366f.png";